var React = require('react');

function External (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Externe link"),React.createElement("g",{"stroke":"#004CA0","fill":"none","fillRule":"evenodd","strokeLinecap":"round","key":1},React.createElement("path",{"d":"M.972 8.028 8 1M2 1h6v6"}))]);
}

External.defaultProps = {"width":"9","height":"9"};

module.exports = External;

External.default = External;
